module.exports = __webpack_public_path__ + "assets/61ef29d188b89076d001212928cae4c9.png";